export const getWebviewDummy = () => ({
  sendAction: () => {},
  close: () => {},
});
